import { INIT_PIE_CHART } from '../../actions/f5-actions/action-types';

const INIT_STATE = {};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_PIE_CHART: {
      return { ...state, ...action.data };
    }
    default:
      return state;
  }
};
